import * as React from "react";

const HeaderCart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" fill="currentColor">
            <path
                fill="#75B8C8"
                d="M4 4V3c0-1.657 1.316-3 3-3a3 3 0 0 1 3 3v1h2.5A1.5 1.5 0 0 1 14 5.5V13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5.5A1.5 1.5 0 0 1 1.5 4H4Zm1 0h4V3a2 2 0 0 0-4 0v1ZM1.5 5a.5.5 0 0 0-.5.5V13a2 2 0 0 0 2 2h8c1.103 0 2-.897 2-2V5.5c0-.275-.225-.5-.5-.5H10v2.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V5H5v2.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V5H1.5Z"
            />
        </svg>
    );
};

export default React.memo(HeaderCart);
